import { IDisplayInfo } from "@/types";
import { sendTransactions } from "@multiversx/sdk-dapp/services/transactions/sendTransactions";
import type { SendTransactionReturnType } from "@multiversx/sdk-dapp/types";
import { refreshAccount } from "@multiversx/sdk-dapp/utils/account/refreshAccount";

export const useRefreshAndSend = () => {
  const refreshAndSend = async (
    transactions: any[],
    message: IDisplayInfo
  ): Promise<SendTransactionReturnType> => {
    await refreshAccount();
    if (!transactions) {
      return Promise.reject(new Error("No transactions to send"));
    }

    return sendTransactions({
      transactions,
      transactionsDisplayInfo: message,
      redirectAfterSign: false,
    });
  };
  return refreshAndSend;
};
